import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { default as ReactCurrencyInput } from 'react-currency-input-field';
import type { CurrencyInputProps } from 'react-currency-input-field';
import { colors, fontSizes } from '@anyroad/theme';

const StyledCurrencyInput = styled(ReactCurrencyInput)({
  width: '100%',
  padding: '14px 15px',
  height: '44px',
  boxSizing: 'border-box',
  border: `1px solid ${colors.borderAction}`,
  borderRadius: '0px',
  background: 'transparent',
  fontSize: fontSizes.medium,
  textAlign: 'right',
});

/**
 * CurrencyInput component.
 *
 * @type {React.FC<CurrencyInputProps>}
 * @returns {React.ReactElement} The currency-input.
 * @example
 * import { CurrencyInput } from './CurrencyInput';
 */
export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  (props, ref) => (
    <StyledCurrencyInput ref={ref} {...props} allowNegativeValue={false} />
  )
);

CurrencyInput.displayName = 'CurrencyInput';
